import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { WithingsOrderPostDetail } from 'features/feed';

type RouteParams = {
  orderPostId: string;
};

const PageWithingsOrderPost = () => {
  const { orderPostId } = useRequiredParams<RouteParams>();

  return (
    <AppLayout aside>
      <WithingsOrderPostDetail orderPostId={orderPostId} />
    </AppLayout>
  );
};

export default PageWithingsOrderPost;
